import { Typography, styled } from "@mui/material";

const TypographyStyled = styled(Typography)(() => ({
  fontSize: "14px",
  fontWeight: 400,
}));

const NormalTextUnstyled = ({ text, className, children }) => (
  <TypographyStyled className={className}>
    {typeof text !== "undefined" ? text : children}
  </TypographyStyled>
);

const NormalText = styled(NormalTextUnstyled)({});

export default NormalText;
